import React, { useState } from "react";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import { Redirect } from "react-router-dom";
import Cookies from "js-cookie";
// import './MasterFile.css';
import "../../GlobalCss/SPF/MasterFile.css";
import { callPaychexUploadTemplateApi } from "../../Repository/MasterFileRepository";
import { Button, Layout, Select, Spin } from "antd";
import MasterFileTable from "../../Components/MasterfileTable/MasterFileTable";
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';
import { ErrorMessage, SuccessMessage, InfoMessage } from "../../Utils/Utils";
const { Header, Content } = Layout;

const Masterfile = () => {
    const jwtToken = Cookies.get("jwt_token");
    const [frequency, setFrequency] = useState('')
    const [spin, setSpin] = useState(false)
    const [masterfileData, setMasterfileData] = useState([])
    const [columns, setColumns] = useState([])
    const [selectToggle, setSelectToggle] = useState(false)
    const [showCols, setShowCols] = useState([])
    const [isDropdownDisabled, setIsDropdownDisabled] = useState(true);
    const [dropdownColumns, setDropdownColumns] = useState([{ 'key': 'selectAll', 'value': 'Select All' }, { 'key': 'flsa', 'value': 'FLSA' }, { 'key': 'term_date', 'value': 'Term Date' },
    { 'key': 'emp_status', 'value': 'Status' }, { 'key': 'period', 'value': 'Period' }, { 'key': 'temp_rate', 'value': 'Temp Rate' }, { 'key': 'rt_wk1', 'value': 'RT Week 1' }, { 'key': 'ot_wk1', 'value': 'OT Week 1' }, { 'key': 'dt_wk1', 'value': 'DT Week 1' }, { 'key': 'status_W', 'value': 'Status W' },
    { 'key': 'rt_wk2', 'value': 'RT Week 2' }, { 'key': 'ot_wk2', 'value': 'OT Week 2' }, { 'key': 'dt_wk2', 'value': 'DT Week 2' }, { 'key': 'status_B', 'value': 'Status B' }, { 'key': 'rt_total', 'value': 'RT total' }, { 'key': 'ot_total', 'value': 'OT total' }, { 'key': 'dt_total', 'value': 'DT total' },
    { 'key': 'sal_amnt', 'value': 'Salary Amount' }, { 'key': 'holiday_hrs', 'value': 'Holiday Hours' }, { 'key': 'sick_hrs', 'value': 'Sick Hours' }, { 'key': 'pto_hrs', 'value': 'PTO Hours' }, { 'key': 'covid_hrs', 'value': 'COVID Hours' }, { 'key': 'training_hrs', 'value': 'Training Hours' },
    { 'key': 'gym_amnt', 'value': 'Gym Amount' }, { 'key': 'fmla_amnt', 'value': 'FMLA Amount' }, { 'key': 'sevpay_amnt', 'value': 'Sev Pay Amount' }, { 'key': 'bonus_amnt', 'value': 'Bonus Amount' }, { 'key': 'missingInPaychexList', 'value': 'Missing In PaychexList' }, { 'key': 'insertDate', 'value': 'Insert Date' },
    { 'key': 'payDate', 'value': 'Pay Date' }, { 'key': 'ticket_Number', 'value': 'Ticket Number' }, { 'key': 'chequesequence', 'value': 'Cheque sequence' }, { 'key': 'remarks', 'value': 'Remarks' }, { 'key': 'ALOT', 'value': 'ALOT' }, { 'key': 'WeekendDate', 'value': 'Weekend Date' },
    ])
    const handleChange = async (props) => {
        // setIsDropdownDisabled(true)
        setFrequency(props.value)
        let prop = props.value
        if (frequency !== null || prop !== null) {
            setIsDropdownDisabled(false)
        }
    }
    const changeDownload = async (props) => {
        let value = props.value
        if (value === "excel" || value === "exceladj" || value === "paychexupload") {
            setSpin(true)
            downloadPaycehx(value)
        }
    }
    const downloadPaycehx = async (prop) => {
        try {
            let val = prop
            // const resp = await selectMasterfileFrequency(frequency, masterfileData);
            const masterData = masterfileData
            if (masterData.length !== 0 && val !== "paychex") {
                let tempList = masterData;
                let loopList = []
                loopList.length = 0;
                let len = tempList.length;
                // Function to sanitize cell values
                const sanitizeCellValue = (value) => {
                    if (typeof value === 'string' && /^[=+\-@]/.test(value.trim())) {
                        return "'" + value; // Prefix with a single quote
                    }
                    return value;
                };
                if (val === "excel") {
                    loopList.push(['Co Code', 'File Number', 'Employee Name', 'Portal Employee Name', 'State',
                        'Client', 'Hire Date', 'Rate Type', 'Payrate', 'Frequency', ' FLSA',
                        'Term Date', 'Status', 'Period', 'Temp Rate', 'RT Week 1',
                        'OT Week 1', 'DT Week 1', 'Status W', 'RT Week 2', 'OT Week 2', 'DT Week 2',
                        'Status B', 'RT Total', 'OT Total', 'DT Total', 'Salary Amount',
                        'Holiday Hours', 'Sick Hours', 'PTO Hours', 'Covid Hours', 'Training Hours',
                        'Gym Amount', 'FMLA Amount', 'Sev Pay Amount', 'Bonus Amount', 'Missing in PaychexList',
                        'Insert Date', 'Pay Date', 'Ticket Number', 'Cheque sequence', 'Remarks', 'ALOT', 'Weekend Date'
                    ])
                    for (let i = 0; i < len; i++) {
                        if (tempList[i].ticket_Number === null || tempList[i].ticket_Number === undefined) {
                            const hrdt = new Date(tempList[i].hire_date)
                            // console.log(tempList[i].hire_date)
                            var newHiredt = parseInt(hrdt.getMonth() + 1) + '/' + parseInt(hrdt.getDate()) + '/' + parseInt(hrdt.getFullYear());
                            let trmdt;
                            var newTermdt;
                            if (tempList[i].term_date !== null) {
                                if (tempList[i].term_date !== undefined) {
                                    trmdt = new Date(tempList[i].term_date);
                                    newTermdt = parseInt(trmdt.getMonth() + 1) + '/' + parseInt(trmdt.getDate()) + '/' + ('0' + '0' + '0' + '0' + parseInt(trmdt.getFullYear())).slice(-4);
                                }
                            }
                            const pydt = new Date(tempList[i].payDate)
                            var newPaydt = parseInt(pydt.getMonth() + 1) + '/' + parseInt(pydt.getDate()) + '/' + parseInt(pydt.getFullYear());
                            let floatRT_Week1;
                            if (tempList[i].rt_wk1 !== null) {
                                if (tempList[i].rt_wk1 !== "") {
                                    floatRT_Week1 = parseFloat(tempList[i].rt_wk1)
                                }
                            }
                            let floatOT_Week1;
                            if (tempList[i].ot_wk1 !== null) {
                                if (tempList[i].ot_wk1 !== "") {
                                    floatOT_Week1 = parseFloat(tempList[i].ot_wk1)
                                }
                            }
                            let floatDT_Week1;
                            if (tempList[i].dt_wk1 !== null) {
                                if (tempList[i].dt_wk1 !== "") {
                                    floatDT_Week1 = parseFloat(tempList[i].dt_wk1)
                                }
                            }
                            let floatRT_Week2;
                            if (tempList[i].rt_wk2 !== null) {
                                if (tempList[i].rt_wk2 !== "") {
                                    floatRT_Week2 = parseFloat(tempList[i].rt_wk2)
                                }
                            }
                            let floatOT_Week2;
                            if (tempList[i].ot_wk2 !== null) {
                                if (tempList[i].ot_wk2 !== "") {
                                    floatOT_Week2 = parseFloat(tempList[i].ot_wk2)
                                }
                            }
                            let floatDT_Week2;
                            if (tempList[i].dt_wk2 !== null) {
                                if (tempList[i].dt_wk2 !== "") {
                                    floatDT_Week2 = parseFloat(tempList[i].dt_wk2)
                                }
                            }
                            let floatRT_Total;
                            if (tempList[i].rt_total !== null) {
                                if (tempList[i].rt_total !== "") {
                                    floatRT_Total = parseFloat(tempList[i].rt_total)
                                }
                            }
                            let floatOT_Total;
                            if (tempList[i].ot_total !== null) {
                                if (tempList[i].ot_total !== "") {
                                    floatOT_Total = parseFloat(tempList[i].ot_total)
                                }
                            }
                            let floatDT_Total;
                            if (tempList[i].dt_total !== null) {
                                if (tempList[i].dt_total !== "") {
                                    floatDT_Total = parseFloat(tempList[i].dt_total)
                                }
                            }
                            let payRate;
                            if (tempList[i].pay_rate !== null) {
                                if (tempList[i].pay_rate !== "") {
                                    payRate = parseFloat(tempList[i].pay_rate)
                                }
                            }
                            let salAmount;
                            if (tempList[i].sal_amnt !== null) {
                                if (tempList[i].sal_amnt !== "") {
                                    salAmount = parseFloat(tempList[i].sal_amnt)
                                }
                            }
                            let holidayHrs;
                            if (tempList[i].holiday_hrs !== null) {
                                if (tempList[i].holiday_hrs !== "") {
                                    holidayHrs = parseFloat(tempList[i].holiday_hrs)
                                }
                            }
                            let sickHrs;
                            if (tempList[i].sick_hrs !== null) {
                                if (tempList[i].sick_hrs !== "") {
                                    sickHrs = parseFloat(tempList[i].sick_hrs)
                                }
                            }
                            let ptoHrs;
                            if (tempList[i].pto_hrs !== null) {
                                if (tempList[i].pto_hrs !== "") {
                                    ptoHrs = parseFloat(tempList[i].pto_hrs)
                                }
                            }
                            let covidHrs;
                            if (tempList[i].covid_hrs !== null) {
                                if (tempList[i].covid_hrs !== "") {
                                    covidHrs = parseFloat(tempList[i].covid_hrs)
                                }
                            }
                            let triningHrs;
                            if (tempList[i].training_hrs !== null) {
                                if (tempList[i].training_hrs !== "") {
                                    triningHrs = parseFloat(tempList[i].training_hrs)
                                }
                            }
                            let gymAmount;
                            if (tempList[i].gym_amnt !== null) {
                                if (tempList[i].gym_amnt !== "") {
                                    gymAmount = parseFloat(tempList[i].gym_amnt)
                                }
                            }
                            let fmlaAmount;
                            if (tempList[i].fmla_amnt !== null) {
                                if (tempList[i].fmla_amnt !== "") {
                                    fmlaAmount = parseFloat(tempList[i].fmla_amnt)
                                }
                            }
                            let sevpayAmount;
                            if (tempList[i].sevpay_amnt !== null) {
                                if (tempList[i].sevpay_amnt !== "") {
                                    sevpayAmount = parseFloat(tempList[i].sevpay_amnt)
                                }
                            }
                            let bonusAmount;
                            if (tempList[i].bonus_amnt !== null) {
                                if (tempList[i].bonus_amnt !== "") {
                                    bonusAmount = parseFloat(tempList[i].bonus_amnt)
                                }
                            }
                            loopList.push([
                                sanitizeCellValue(tempList[i].comp_code),
                                sanitizeCellValue(tempList[i].file_number),
                                sanitizeCellValue(tempList[i].pcx_emp_name),
                                sanitizeCellValue(tempList[i].portal_emp_name),
                                sanitizeCellValue(tempList[i].state),
                                sanitizeCellValue(tempList[i].client),
                                newHiredt,
                                sanitizeCellValue(tempList[i].rate_type),
                                payRate,
                                sanitizeCellValue(tempList[i].pay_frequency),
                                sanitizeCellValue(tempList[i].flsa),
                                newTermdt,
                                sanitizeCellValue(tempList[i].emp_status),
                                sanitizeCellValue(tempList[i].period),
                                sanitizeCellValue(tempList[i].temp_rate),
                                floatRT_Week1,
                                floatOT_Week1,
                                floatDT_Week1,
                                sanitizeCellValue(tempList[i].status_W),
                                floatRT_Week2,
                                floatOT_Week2,
                                floatDT_Week2,
                                sanitizeCellValue(tempList[i].status_B),
                                floatRT_Total,
                                floatOT_Total,
                                floatDT_Total,
                                salAmount,
                                holidayHrs,
                                sickHrs,
                                ptoHrs,
                                covidHrs,
                                triningHrs,
                                gymAmount,
                                fmlaAmount,
                                sevpayAmount,
                                bonusAmount,
                                sanitizeCellValue(tempList[i].missingInPaychexList),
                                sanitizeCellValue(tempList[i].insertDate),
                                newPaydt,
                                sanitizeCellValue(tempList[i].ticket_Number),
                                sanitizeCellValue(tempList[i].chequesequence),
                                sanitizeCellValue(tempList[i].remarks),
                                sanitizeCellValue(tempList[i].ALOT),
                                sanitizeCellValue(tempList[i].WeekendDate)
                            ])
                        }
                    }
                }
                else if (val === "exceladj") {
                    loopList.push(['Co Code', 'File Number', 'Employee Name', 'Portal Employee Name', 'State',
                        'Client', 'Hire Date', 'Rate Type', 'Payrate', 'Frequency', ' FLSA',
                        'Term Date', 'Status', 'Period', 'Temp Rate', 'RT Week 1',
                        'OT Week 1', 'DT Week 1', 'Status W', 'RT Week 2', 'OT Week 2', 'DT Week 2',
                        'Status B', 'RT Total', 'OT Total', 'DT Total', 'Salary Amount',
                        'Holiday Hours', 'Sick Hours', 'PTO Hours', 'Covid Hours', 'Training Hours',
                        'Gym Amount', 'FMLA Amount', 'Sev Pay Amount', 'Bonus Amount', 'Missing in PaychexList',
                        'Insert Date', 'Pay Date', 'Ticket Number', 'Cheque sequence', 'Remarks', 'ALOT', 'Weekend Date'
                    ])
                    for (let i = 0; i < len; i++) {
                        // if (tempList[i].ticket_Number !== null) {
                        const hrdt = new Date(tempList[i].hire_date)
                        var newHiredt = parseInt(hrdt.getMonth() + 1) + '/' + parseInt(hrdt.getDate()) + '/' + parseInt(hrdt.getFullYear());
                        let trmdt;
                        var newTermdt;
                        if (tempList[i].term_date !== null) {
                            if (tempList[i].term_date !== undefined) {
                                trmdt = new Date(tempList[i].term_date);
                                newTermdt = parseInt(trmdt.getMonth() + 1) + '/' + parseInt(trmdt.getDate()) + '/' + ('0' + '0' + '0' + '0' + parseInt(trmdt.getFullYear())).slice(-4);
                            }
                        }
                        const pydt = new Date(tempList[i].payDate)
                        var newPaydt = parseInt(pydt.getMonth() + 1) + '/' + parseInt(pydt.getDate()) + '/' + parseInt(pydt.getFullYear());
                        let floatRT_Week1;
                        if (tempList[i].rt_wk1 !== null) {
                            if (tempList[i].rt_wk1 !== "") {
                                floatRT_Week1 = parseFloat(tempList[i].rt_wk1)
                            }
                        }
                        let floatOT_Week1;
                        if (tempList[i].ot_wk1 !== null) {
                            if (tempList[i].ot_wk1 !== "") {
                                floatOT_Week1 = parseFloat(tempList[i].ot_wk1)
                            }
                        }
                        let floatDT_Week1;
                        if (tempList[i].dt_wk1 !== null) {
                            if (tempList[i].dt_wk1 !== "") {
                                floatDT_Week1 = parseFloat(tempList[i].dt_wk1)
                            }
                        }
                        let floatRT_Week2;
                        if (tempList[i].rt_wk2 !== null) {
                            if (tempList[i].rt_wk2 !== "") {
                                floatRT_Week2 = parseFloat(tempList[i].rt_wk2)
                            }
                        }
                        let floatOT_Week2;
                        if (tempList[i].ot_wk2 !== null) {
                            if (tempList[i].ot_wk2 !== "") {
                                floatOT_Week2 = parseFloat(tempList[i].ot_wk2)
                            }
                        }
                        let floatDT_Week2;
                        if (tempList[i].dt_wk2 !== null) {
                            if (tempList[i].dt_wk2 !== "") {
                                floatDT_Week2 = parseFloat(tempList[i].dt_wk2)
                            }
                        }
                        let floatRT_Total;
                        if (tempList[i].rt_total !== null) {
                            if (tempList[i].rt_total !== "") {
                                floatRT_Total = parseFloat(tempList[i].rt_total)
                            }
                        }
                        let floatOT_Total;
                        if (tempList[i].ot_total !== null) {
                            if (tempList[i].ot_total !== "") {
                                floatOT_Total = parseFloat(tempList[i].ot_total)
                            }
                        }
                        let floatDT_Total;
                        if (tempList[i].dt_total !== null) {
                            if (tempList[i].dt_total !== "") {
                                floatDT_Total = parseFloat(tempList[i].dt_total)
                            }
                        }
                        let payRate;
                        if (tempList[i].pay_rate !== null) {
                            if (tempList[i].pay_rate !== "") {
                                payRate = parseFloat(tempList[i].pay_rate)
                            }
                        }
                        let salAmount;
                        if (tempList[i].sal_amnt !== null) {
                            if (tempList[i].sal_amnt !== "") {
                                salAmount = parseFloat(tempList[i].sal_amnt)
                            }
                        }
                        let holidayHrs;
                        if (tempList[i].holiday_hrs !== null) {
                            if (tempList[i].holiday_hrs !== "") {
                                holidayHrs = parseFloat(tempList[i].holiday_hrs)
                            }
                        }
                        let sickHrs;
                        if (tempList[i].sick_hrs !== null) {
                            if (tempList[i].sick_hrs !== "") {
                                sickHrs = parseFloat(tempList[i].sick_hrs)
                            }
                        }
                        let ptoHrs;
                        if (tempList[i].pto_hrs !== null) {
                            if (tempList[i].pto_hrs !== "") {
                                ptoHrs = parseFloat(tempList[i].pto_hrs)
                            }
                        }
                        let covidHrs;
                        if (tempList[i].covid_hrs !== null) {
                            if (tempList[i].covid_hrs !== "") {
                                covidHrs = parseFloat(tempList[i].covid_hrs)
                            }
                        }
                        let triningHrs;
                        if (tempList[i].training_hrs !== null) {
                            if (tempList[i].training_hrs !== "") {
                                triningHrs = parseFloat(tempList[i].training_hrs)
                            }
                        }
                        let gymAmount;
                        if (tempList[i].gym_amnt !== null) {
                            if (tempList[i].gym_amnt !== "") {
                                gymAmount = parseFloat(tempList[i].gym_amnt)
                            }
                        }
                        let fmlaAmount;
                        if (tempList[i].fmla_amnt !== null) {
                            if (tempList[i].fmla_amnt !== "") {
                                fmlaAmount = parseFloat(tempList[i].fmla_amnt)
                            }
                        }
                        let sevpayAmount;
                        if (tempList[i].sevpay_amnt !== null) {
                            if (tempList[i].sevpay_amnt !== "") {
                                sevpayAmount = parseFloat(tempList[i].sevpay_amnt)
                            }
                        }
                        let bonusAmount;
                        if (tempList[i].bonus_amnt !== null) {
                            if (tempList[i].bonus_amnt !== "") {
                                bonusAmount = parseFloat(tempList[i].bonus_amnt)
                            }
                        }
                        loopList.push([
                            sanitizeCellValue(tempList[i].comp_code),
                            sanitizeCellValue(tempList[i].file_number),
                            sanitizeCellValue(tempList[i].pcx_emp_name),
                            sanitizeCellValue(tempList[i].portal_emp_name),
                            sanitizeCellValue(tempList[i].state),
                            sanitizeCellValue(tempList[i].client),
                            newHiredt,
                            sanitizeCellValue(tempList[i].rate_type),
                            payRate,
                            sanitizeCellValue(tempList[i].pay_frequency),
                            sanitizeCellValue(tempList[i].flsa),
                            newTermdt,
                            sanitizeCellValue(tempList[i].emp_status),
                            sanitizeCellValue(tempList[i].period),
                            sanitizeCellValue(tempList[i].temp_rate),
                            floatRT_Week1,
                            floatOT_Week1,
                            floatDT_Week1,
                            sanitizeCellValue(tempList[i].status_W),
                            floatRT_Week2,
                            floatOT_Week2,
                            floatDT_Week2,
                            sanitizeCellValue(tempList[i].status_B),
                            floatRT_Total,
                            floatOT_Total,
                            floatDT_Total,
                            salAmount,
                            holidayHrs,
                            sickHrs,
                            ptoHrs,
                            covidHrs,
                            triningHrs,
                            gymAmount,
                            fmlaAmount,
                            sevpayAmount,
                            bonusAmount,
                            sanitizeCellValue(tempList[i].missingInPaychexList),
                            sanitizeCellValue(tempList[i].insertDate),
                            newPaydt,
                            sanitizeCellValue(tempList[i].ticket_Number),
                            sanitizeCellValue(tempList[i].chequesequence),
                            sanitizeCellValue(tempList[i].remarks),
                            sanitizeCellValue(tempList[i].ALOT),
                            sanitizeCellValue(tempList[i].WeekendDate)
                        ])
                        // }
                    }
                }
                else if (val === "paychexupload") {
                    loopList.push(['Client ID', 'Worker ID', 'Org', 'Job Number', 'Pay Component', 'Rate', 'Rate Number',
                        'Hours', 'Units', 'Line Date', 'Amount', 'Check Seq Number', 'Override State', 'Override Local',
                        'Override Local Jurisdiction', 'Labor Assignment'])
                    const resp = await callPaychexUploadTemplateApi(frequency);
                    if (resp.data.statusCode === 200) {
                        const temp = JSON.parse(resp.data.payload);
                        temp.forEach(e => {
                            loopList.push([
                                e.Client_ID,
                                e.Worker_ID,
                                e.Org,
                                e.Job_Number,
                                e.Pay_Component,
                                e.Rate,
                                e.Rate_Number,
                                e.Hours,
                                e.Units,
                                e.Line_Date,
                                e.Amount,
                                e.Check_Seq_Number,
                                e.Override_State,
                                e.Override_Local,
                                e.Override_Local_Jurisdiction,
                                e.Labor_Assignment
                            ])
                        });
                    }
                    else if (resp.data.statusCode === 500) {
                        InfoMessage(resp.data.message);
                    }
                    else {
                        ErrorMessage("Cannot able to fetch data, please try again later");
                    }
                }
                else {
                    loopList.push(['Co Code', 'File Number', 'Employee Name', 'Portal Employee Name', 'State',
                        'Client', 'Hire Date', 'Rate Type', 'Payrate', 'Frequency', ' FLSA',
                        'Term Date', 'Status', 'Period', 'Temp Rate', 'RT Week 1',
                        'OT Week 1', 'DT Week 1', 'Status W', 'RT Week 2', 'OT Week 2', 'DT Week 2',
                        'Status B', 'RT Total', 'OT Total', 'DT Total', 'Salary Amount',
                        'Holiday Hours', 'Sick Hours', 'PTO Hours', 'Covid Hours', 'Training Hours',
                        'Gym Amount', 'FMLA Amount', 'Sev Pay Amount', 'Bonus Amount', 'Missing in PaychexList',
                        'Insert Date', 'Pay Date', 'Ticket Number', 'Remarks', 'Weekend Date'
                    ])
                    for (let i = 0; i < len; i++) {
                        loopList.push([
                            // tempList[i].id,
                            sanitizeCellValue(tempList[i].comp_code),
                            sanitizeCellValue(tempList[i].file_number),
                            sanitizeCellValue(tempList[i].pcx_emp_name),
                            sanitizeCellValue(tempList[i].portal_emp_name),
                            sanitizeCellValue(tempList[i].state),
                            sanitizeCellValue(tempList[i].client),
                            sanitizeCellValue(tempList[i].hire_date),
                            sanitizeCellValue(tempList[i].rate_type),
                            sanitizeCellValue(tempList[i].pay_rate),
                            sanitizeCellValue(tempList[i].pay_frequency),
                            sanitizeCellValue(tempList[i].flsa),
                            sanitizeCellValue(tempList[i].term_date),
                            sanitizeCellValue(tempList[i].emp_status),
                            sanitizeCellValue(tempList[i].period),
                            sanitizeCellValue(tempList[i].temp_rate),
                            sanitizeCellValue(tempList[i].rt_wk1),
                            // floatRT_Week1,
                            sanitizeCellValue(tempList[i].ot_wk1),
                            // floatOT_Week1,
                            sanitizeCellValue(tempList[i].dt_wk1),
                            sanitizeCellValue(tempList[i].status_W),
                            sanitizeCellValue(tempList[i].rt_wk2),
                            // floatRT_Week2,
                            // floatOT_Week2,
                            sanitizeCellValue(tempList[i].ot_wk2),
                            sanitizeCellValue(tempList[i].dt_wk2),
                            sanitizeCellValue(tempList[i].status_B),
                            sanitizeCellValue(tempList[i].rt_total),
                            sanitizeCellValue(tempList[i].ot_total),
                            sanitizeCellValue(tempList[i].dt_total),
                            sanitizeCellValue(tempList[i].sal_amnt),
                            sanitizeCellValue(tempList[i].holiday_hrs),
                            sanitizeCellValue(tempList[i].sick_hrs),
                            sanitizeCellValue(tempList[i].pto_hrs),
                            sanitizeCellValue(tempList[i].covid_hrs),
                            sanitizeCellValue(tempList[i].training_hrs),
                            sanitizeCellValue(tempList[i].gym_amnt),
                            sanitizeCellValue(tempList[i].fmla_amnt),
                            sanitizeCellValue(tempList[i].sevpay_amnt),
                            sanitizeCellValue(tempList[i].bonus_amnt),
                            sanitizeCellValue(tempList[i].missingInPaychexList),
                            sanitizeCellValue(tempList[i].insertDate),
                            sanitizeCellValue(tempList[i].payDate),
                            sanitizeCellValue(tempList[i].ticket_Number),
                            sanitizeCellValue(tempList[i].remarks),
                            sanitizeCellValue(tempList[i].WeekendDate)
                        ])
                    }
                }
                handlePaychexExport(loopList, val);
            }
            else { setSpin(false) }
        }
        catch (err) {
            setSpin(false)
            return null
        }
    }
    const handlePaychexExport = async (props, val) => {
        try {
            const payData = props;
            const value = val;
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            for (let i = 0; i < payData.length; i++) {
                worksheet.addRow(payData[i]);
                if (value === 'excel' || value === "exceladj") {
                    if (payData[i][41] !== null && payData[i][41] !== "" && i !== 0) {
                        // console.log(payData[i])
                        worksheet.getRow(i + 1).fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: "FFA500" },
                        };
                    }
                }
            }
            if (value === 'excel' || value === "exceladj") {
                setSpin(false)
                SuccessMessage("Downloaded successfully !!")
                return workbook.xlsx.writeBuffer()
                    .then(buffer => {
                        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        FileSaver.saveAs(blob, 'PaychexReport.xlsx');
                    });
            }
            else if (value === 'csv' || value === "paychexupload") {
                setSpin(false)
                SuccessMessage("Downloaded successfully !!")
                return workbook.csv.writeBuffer()
                    .then(buffer => {
                        const blob = new Blob([buffer], { type: 'text/csv;charset=utf-8' });
                        FileSaver.saveAs(blob, 'PaychexReport.csv');
                    });
            }
            else if (value === "paychexupload") {
                setSpin(false)
                SuccessMessage("Downloaded successfully !!")
                return workbook.csv.writeBuffer()
                    .then(buffer => {
                        const blob = new Blob([buffer], { type: 'text/csv;charset=utf-8' });
                        FileSaver.saveAs(blob, 'PaychexUploadTemplate.csv');
                    });
            }
            else {
                setSpin(false)
                return null;
            }
        }
        catch (err) {
            setSpin(false)
            return ErrorMessage("Cannot able download, please try again")
        }
    };
    const callTableColumns = (e, key) => {
        if (key.length > 0) {
            const isSelectAllSelected = key.some(item => item.key === 'selectAll');
            if (isSelectAllSelected && selectToggle === false) {
                const filteredData = dropdownColumns.filter(item => item.key !== 'selectAll');
                setColumns(filteredData);
                setShowCols(dropdownColumns);
                setSelectToggle(true)
            }
            else if (!isSelectAllSelected && selectToggle === true) {
                setColumns([])
                setShowCols([])
                setSelectToggle(false)
            }
            else {
                setSelectToggle(false)
                const filteredData = key.filter(item => item.key !== 'selectAll');
                setColumns(filteredData);
                setShowCols(filteredData)
            }
        } else {
            setColumns(key);
            setShowCols(key)
            setSelectToggle(false)
        }
    }
    if (jwtToken === undefined) {
        return <Redirect to="/" />;
    }

    return (
        <>
            <Layout style={{ backgroundColor: "white", overflow: "hidden", height: "100vh", display: "flex" }} className="layout-class">
                <SideNavBar />
                <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
                    <Header className="masterfile-header">
                        <Navbar />
                    </Header>
                    <Content className="masterfile-content-class">
                        {/* <div className="masterfile-dropdowns-content"> */}

                        <div className="masterfile-dropdowns">
                            <div className="master-heading">
                                <div style={{ borderBottom: "1px solid #4B4B4B" }}>Master File</div></div>
                        </div>
                        <div className="masterfile-dropdowns-content">
                            <div className="mf-dropdown">
                                <Select
                                    labelInValue
                                    placeholder={<span className="placeholder-span" style={{ color: 'rgba(59, 82, 223, 1)' }}>Select Frequency</span>}
                                    style={{ width: 170, height: 40 }} size="large"
                                    className="master-frequency-select"
                                    onChange={handleChange}
                                    options={[{ value: 'Weekly', label: 'Weekly', },
                                    { value: 'Bi-weekly', label: 'Bi-weekly', },]}
                                />
                                <div className="select-columns-dropdown">
                                    <Select
                                        className="master-frequency-select"
                                        mode="multiple"
                                        size="large"
                                        style={{ width: 170, height: 40 }}
                                        placeholder={<span className="placeholder-span" style={{ color: 'rgba(59, 82, 223, 1)' }}>Select Columns</span>}
                                        maxTagCount="responsive"
                                        allowClear
                                        value={showCols}
                                        onChange={(newval, item) => callTableColumns(newval, item)}>
                                        {
                                            dropdownColumns ? dropdownColumns.map((item) => {
                                                return (<Select.Option key={item.key} value={item.value}>
                                                    {item.value}
                                                </Select.Option>)
                                            }) : null}
                                    </Select>
                                    {/* <Button className="checks-yes-button" onClick={settingColumns}>Done</Button> */}
                                </div>
                                <div className="downdrop-loader">
                                    <Select
                                        labelInValue
                                        placeholder={<span className="placeholder-span" style={{ color: 'rgba(59, 82, 223, 1)' }}>Download as</span>}
                                        style={{
                                            width: 170, height: 40
                                        }} size="large"
                                        className="master-frequency-select"
                                        onSelect={changeDownload}
                                        options={[{ value: 'exceladj', label: 'Export /.XLSX (with Adjustments) ', },
                                        { value: 'excel', label: 'Export /.XLSX (without Adjustments) ', },
                                        { value: 'paychexupload', label: 'Paychex Upload File' },
                                            // { value: 'paychex', label: 'Export to paychex', disabled: true, },
                                        ]}

                                    />
                                    {spin ? <div className="xl-spinner"><Spin size="medium" /></div> : null}
                                </div>
                            </div>
                        </div>
                        <MasterFileTable selectfrequency={frequency} dataColumns={columns} sendDataToParent={setMasterfileData} />
                    </Content>
                </Layout>
            </Layout>
        </>
    )
}
export default Masterfile;
